
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MultiSelectModel } from '../../models/multi-select.model';
import { MatFormField, MatInput } from '@angular/material/input';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { AsyncPipe } from '@angular/common';
import { MatOption } from '@angular/material/select';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'multiselect-autocomplete',
    templateUrl: './multiselect-autocomplete.component.html',
    styleUrls: ['./multiselect-autocomplete.component.scss'],
    imports: [MatFormField, MatInput, MatAutocompleteTrigger, FormsModule, ReactiveFormsModule, MatAutocomplete, MatOption, MatCheckbox, MatChipListbox, MatChipOption, MatIcon, AsyncPipe]
})
export class MultiselectAutocompleteComponent implements OnInit {

  @Output() result = new EventEmitter<{ key: string, data: Array<MultiSelectModel> }>();

  @Input() placeholder: string = 'Select Data';
  @Input() data: Array<MultiSelectModel> = [];
  @Input() key: string = '';
  @Input() selectData: Array<MultiSelectModel> = [];

  selectControl = new FormControl();

  // Always the current input list: callers push options into it when their request answers, which can be after
  // this component is created (a copy taken in ngOnInit stayed empty until a reload).
  get rawData(): Array<MultiSelectModel> {
    return this.data ?? [];
  }

  filteredData: Observable<Array<MultiSelectModel>>;
  filterString: string = '';

  constructor() {
    this.filteredData = this.selectControl.valueChanges.pipe(
      startWith<string>(''),
      map(value => typeof value === 'string' ? value : this.filterString),
      map(filter => this.filter(filter))
    );
  }

  ngOnInit(): void {
    this.data.forEach((item: MultiSelectModel) => {
      if (item.selected) {
        this.selectData.push(item)
      }
    });
  }

  filter = (filter: string): Array<MultiSelectModel> => {
    this.filterString = filter;
    if (filter.length > 0) {
      return this.rawData.filter((option: MultiSelectModel) => {
        return option.itemDescription.toLowerCase().indexOf(filter.toLowerCase()) >= 0;
      });
    } else {
      return this.rawData;
    }
  };

  displayFn = (): string => '';

  openedChange(opened: any) {
    console.log(opened ? 'opened' : 'closed');
}
  optionClicked = (event: Event, data: MultiSelectModel): void => {
    event.stopPropagation();
    this.toggleSelection(data);
  };

  toggleSelection = (data: MultiSelectModel): void => {
    data.selected = !data.selected;

    if (data.selected === true) {
      this.selectData.push(data);
    } else {
      const i = this.selectData.findIndex(value => value.itemKey === data.itemKey);
      this.selectData.splice(i, 1);
    }

    // this.selectControl.setValue(this.filterString);
    // this.filter(this.filterString);
    this.emitAdjustedData();
  };

  emitAdjustedData = (): void => {
    const results: Array<MultiSelectModel> = []
    this.selectData.forEach((data: MultiSelectModel) => {
      if(data.selected)
        results.push(data);
    });
    this.result.emit({ key: this.key, data: results });
  };

  clenAllSelections() {
    this.selectData.forEach((data: MultiSelectModel) => {
      // this.removeChip(data)
      data.selected = false;
    });
    this.emitAdjustedData();
  }

  removeChip = (data: MultiSelectModel): void => {
    this.toggleSelection(data);
  };

}